import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    urlUpdate: String,
    controller: String
  }

  handleClick(event) {
    if (this.controllerValue !== "meetings") {
      const closestLink = event.target.closest("a");
      if (closestLink) closestLink.click();
      return;
    }

    const closestTd = event.target.closest("td");
    if (!closestTd) return;

    const targetClasses = event.target.classList;
    if (targetClasses.contains("fc-title") || targetClasses.contains("fc-content") || targetClasses.contains("fc-time")) {
      return;
    }

    const currentDay = closestTd.dataset.day;
    if (!currentDay) return;

    const { today, selected } = this.midnightBounds(currentDay);
    if (today > selected) return;

    const isToday = today.getTime() === selected.getTime();
    const now = isToday ? new Date() : null;
    const normalized = this.normalizeTime(
      isToday ? now.getHours() : 11,
      isToday ? now.getMinutes() : 30
    );

    this.requestTurboStream(currentDay, normalized.hour, normalized.minute);
  }

  normalizeTime(hour, minute) {
    let normalizedHour = parseInt(hour, 10);
    let normalizedMinute = Math.ceil(parseInt(minute, 10) / 5) * 5;

    if (normalizedMinute >= 60) {
      normalizedHour = (normalizedHour + 1) % 24;
      normalizedMinute = 0;
    }

    if (normalizedMinute < 0) {
      normalizedHour = (normalizedHour - 1 + 24) % 24;
      normalizedMinute = 60 + normalizedMinute;
    }

    return { hour: normalizedHour, minute: normalizedMinute };
  }

  requestTurboStream(current_day, hour, minute) {
    const urlUpdate = this.urlUpdateValue
    const separator = urlUpdate.includes('?') ? '&' : '?';
    const url = `${urlUpdate}${separator}current_day=${current_day}&hour=${hour}&minute=${minute}`;

    fetch(url)
      .then(response => response.text())
      .then(html => this.showModal(html))
      .catch(error => console.error('Error:', error));
  }

  showModal(html) {
    const modal = this.ensureModalShell(document.getElementById('meetingModal'));
    modal.querySelector('.modal-body').innerHTML = this.extractBody(html);
    $(modal).modal('show');
  }

  midnightBounds(dayString) {
    const today = new Date();
    const selected = new Date(dayString);

    today.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    return { today, selected };
  }

  ensureModalShell(modal) {
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'meetingModal';
      modal.tabIndex = -1;
      modal.setAttribute('role', 'dialog');
      modal.className = 'modal fade meeting-modal__modal';
      modal.innerHTML = `
        <div class="modal-dialog modal-dialog-centered modal-xl meeting-modal__dialog" role="document">
          <div class="modal-content border-0 shadow-none meeting-modal__container position-relative">
            <div class="modal-body p-0 meeting-modal__wrapper"></div>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
    } else {
      modal.classList.add('meeting-modal__modal');
    }

    return modal;
  }

  extractBody(html) {
    try {
      const parser = new DOMParser();
      const parsed = parser.parseFromString(html, 'text/html');
      const bodyContent = parsed.body && parsed.body.innerHTML.trim();
      return bodyContent || html;
    } catch (error) {
      console.warn('Failed to parse meeting modal HTML:', error);
      return html;
    }
  }
}
